

(function($) { "use strict";
	// book-a-ticket page
	if( $('.section-container-book-a-ticket').length ) {
		//Show More button, if there's more content
		if ($('.book-a-ticket-show-more-content').length) {
			//show the button container
			$('.book-a-ticket-show-more').removeClass('js-hidden');
			//show content on click
			$('.book-a-ticket-show-more-button').click( function(e) {
				e.preventDefault();
				$(this).addClass('js-hidden');
				$('.book-a-ticket-show-more-content').removeClass('js-hidden');
			});
		}

	}
})(jQuery);






